import * as type from '@xfe-team/utils/src/type-utils';
import * as common from '@xfe-team/utils/src/common-util';

export default class ScriptModel {
  constructor({ condition = true, script, env, resolve, reject, prepare = common.noop }) {
    this.condition = condition;
    this.script = script;
    /**
     * 当 env 存在时才有 normalize 的意义
     */
    this.env = env && ScriptModel.normalizeEnv(env);
    this.prepare = prepare;
    this.resolve = resolve;
    this.reject = reject;
  }

  static normalizeEnv(env) {
    return type.isArray(env) ? env : [env];
  }
}
